var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdvisor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1281_1839)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.99902 16.5C8.00152 16.5 11.999 17.505 11.999 19.5V21H-0.000976562V19.5C-0.000976562 17.505 3.99652 16.5 5.99902 16.5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.99902 15C7.65652 15 8.99902 13.6575 8.99902 12C8.99902 10.3425 7.65652 9 5.99902 9C4.34152 9 2.99902 10.3425 2.99902 12C2.99902 13.6575 4.34152 15 5.99902 15Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 4H22V16H13V18H22C23.1046 18 24 17.1046 24 16V4C24 2.89543 23.1046 2 22 2H8C6.89543 2 6 2.89543 6 4V5.42859H8V4Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 6,
    width: 8,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 9,
    width: 8,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 12,
    width: 4,
    height: 2,
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1281_1839"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvisor);
export default __webpack_public_path__ + "static/media/advisor.213763f8.svg";
export { ForwardRef as ReactComponent };